import React from 'react';
import './OurTeam.css';
import { FaUserTie, FaHandshake, FaShieldAlt } from 'react-icons/fa';
import { GiTargetPrize } from 'react-icons/gi';

const OurTeam = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'Dikendra Raya',
      position: 'CEO & Founder',
      department: 'Leadership & Strategy',
      experience: '12+ years in E-commerce & Retail',
      education: 'MBA in Business Strategy, Harvard Business School',
      icon: <FaUserTie />,
      color: '#FF6B6B',
      description: 'Visionary leader with extensive experience in transforming traditional retail into digital success stories. Dikendra pioneered the concept of fusion fashion in Nepal, blending traditional Nepali craftsmanship with modern design.',
      expertise: ['Business Strategy', 'Digital Transformation', 'Market Expansion', 'Brand Development'],
      achievements: [
        'Named "E-commerce Entrepreneur of the Year 2023" by Nepal Business Council',
        'Expanded NepliShop to 3 international markets',
        'Achieved 300% growth in 2 years'
      ],
      quote: "Fashion should empower, not just adorn. At NepliShop, we're redefining Nepali fashion for the global stage.",
      social: {
        linkedin: '#',
        twitter: '#',
        instagram: '#',
        email: 'dikendra@neplishop.com'
      }
    },
    {
      id: 2,
      name: 'MD Mohatab Miya',
      position: 'CTO & Head of Innovation',
      department: 'Technology & Operations',
      experience: '10+ years in Tech & E-commerce Platforms',
      education: 'MSc Computer Science, MIT | Certified AWS Solutions Architect',
      icon:  <FaUserTie />,
      color: '#4ECDC4',
      description: 'Tech innovator specializing in scalable e-commerce solutions. Mahatab architected our entire tech stack, ensuring seamless shopping experiences across all devices and markets.',
      expertise: ['Cloud Architecture', 'AI/ML Integration', 'Security Systems', 'Mobile Development'],
      achievements: [
        'Developed proprietary recommendation engine boosting sales by 40%',
        'Implemented AI-powered inventory management reducing waste by 25%',
        'Led team that achieved 99.9% uptime for 3 consecutive years'
      ],
      quote: "Technology should enhance human experiences, not replace them. We build solutions that make fashion accessible to everyone.",
      social: {
        linkedin: '#',
        twitter: '#',
        github: '#',
        email: 'mahatab@neplishop.com'
      }
    },
    {
      id: 3,
      name: 'Nishant Shreastha',
      position: 'CFO & Business Development Head',
      department: 'Finance & Growth',
      experience: '15+ years in Finance & Retail Management',
      education: 'CPA, ACCA | MBA Finance, London Business School',
      icon:  <FaUserTie />,
      color: '#FFD166',
      description: 'Financial strategist and growth expert who transformed NepliShop from a local startup to a multi-million dollar enterprise. Nishant specializes in sustainable business growth and strategic partnerships.',
      expertise: ['Financial Planning', 'Investment Strategy', 'Business Development', 'Risk Management'],
      achievements: [
        'Secured Series B funding of $5M for international expansion',
        'Established partnerships with 50+ international brands',
        'Reduced operational costs by 30% while increasing revenue'
      ],
      quote: "Sustainable growth comes from balancing innovation with fiscal responsibility. We invest in what truly matters - our customers and quality.",
      social: {
        linkedin: '#',
        twitter: '#',
        instagram: '#',
        email: 'nishant@neplishop.com'
      }
    }
  ];

  const companyValues = [
    {
      icon: <GiTargetPrize />,
      title: 'Our Mission',
      description: 'To revolutionize fashion retail in Nepal by providing quality, trendy clothing while preserving traditional craftsmanship and empowering local communities.'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Our Vision',
      description: 'To become South Asia\'s premier fashion destination, known for quality, innovation, and exceptional customer experiences.'
    },
    {
      icon: <FaHandshake />,
      title: 'Our Values',
      description: 'Quality craftsmanship, customer-centric approach, innovation, sustainability, and community empowerment drive everything we do.'
    }
  ];

  // ... rest of the component remains the same

  return (
    <div className="our-team-page">
  
      {/* Leadership Team Section */}
      <div className="leadership-section">
        <div className="section-header">
          <h2>Executive Leadership</h2>
          <p className="section-subtitle">
            Our leadership team brings together diverse expertise to drive NepliShop's vision forward
          </p>
        </div>

        <div className="team-members-grid">
          {teamMembers.map(member => (
            <div key={member.id} className="team-member-card">
              <div className="member-header">
                <div 
                  className="member-icon-container"
                  style={{ background: `linear-gradient(135deg, ${member.color}, ${member.color}99)` }}
                >
                  <div className="member-icon">
                    {member.icon}
                  </div>
                </div>
                <div className="member-basic-info">
                  <h3 className="member-name">{member.name}</h3>
                  
                 
                </div>
              </div>

             

     
            </div>
          ))}
        </div>
      </div>

      {/* Company Values Section */}
      <div className="values-section">
        <div className="section-header">
          <h2>Our Guiding Principles</h2>
          <p className="section-subtitle">
            The values that shape our decisions and drive our success
          </p>
        </div>

        <div className="values-grid">
          {companyValues.map((value, index) => (
            <div key={index} className="value-card">
              <div className="value-icon">
                {value.icon}
              </div>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Team Culture Section */}
      <div className="culture-section">
       
We are three friends currently pursuing our bachelor’s degree in Kathmandu. One day, we suddenly came up with the idea of opening our own brand that is fully focused on clothing and shoes for men, women, and kids at affordable prices for everyone.

We are young entrepreneurs who want to grow our brand and turn it into a large company. Our primary goal is to satisfy customer needs and make them happy with our service.

Now, you may be wondering how these three friends came up with the idea of creating a Nepali-based online shopping platform. The answer is simple. We were inspired by content creators on social media who do similar work. However, the difference is that many of them lack proper goals and guidance. They simply post content, sell products, and later deliver damaged or low-quality items to customers.

We experienced this ourselves, which motivated us to change the system and prove that online shopping can be reliable, with products delivered safely and in good condition.
      </div>

 
    
    </div>
  );
};

export default OurTeam;
